import getDeploymentStage from './getDeploymentStage';

export const IS_DEV = process.env['NODE_ENV'] === 'development';

export const isProductionStage = getDeploymentStage() === 'production';
